// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__Aymq9","notFountText":"notFound_notFountText__FM-3d","goToHomepageBtn":"notFound_goToHomepageBtn__H+-Cj"};